export default __webpack_public_path__ + "static/media/b5.e8f01e50.jpg";